export async function executeExportYtLoop(seedPrompt: string): Promise<string> {
    const lower = seedPrompt.toLowerCase();
    
    // Extract YouTube URL using a basic regex
    const urlMatch = seedPrompt.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/[^\s]+/i);
    if (!urlMatch) return '';
    const url = urlMatch[0];

    let action = '';
    if (lower.includes('download youtube video')) action = 'download-video';
    else if (lower.includes('download audio')) action = 'download-audio';
    else if (lower.includes('export comments')) action = 'export-comments';
    else if (lower.includes('comment raffle')) action = 'raffle';

    const actionAttr = action ? ` action="${action}"` : '';
    
    return `\n\n[Export-YT Context:\n<exportyt-widget url="${url}"${actionAttr}></exportyt-widget>\n]`;
}
